import URLConst from '../constants/URLConst';
import { fetchJSON, secureDELETE, secureGET, securePOST, securePUT } from '../utilities/FetchHelper';

class RatesConfigurationService {

    getConfigurableRates() {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATES_GET_POST

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    addConfigurableRates(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATES_GET_POST
    
        return fetchJSON(url, { ...securePOST(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
    
    updateConfigurableRates(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATES_PUT_DELETE
        url = url.replace('{code}', data.code)
        
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
    
    deleteConfigurableRates(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_RATES_PUT_DELETE
        url = url.replace('{code}', data.code)
        
        return fetchJSON(url, { ...secureDELETE(true), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new RatesConfigurationService()